import { Spinner } from '@frontend/components/common';
import { IdentificationClient } from '@frontend/identification/api';
import { CommonMessage } from '@frontend/lang';
import { ToastUtil } from '@frontend/toast-utils';
import { FormattedMessage } from 'react-intl';

import { DeleteModal } from '../../../../modal/delete-modal/delete-modal.component';
import { DefaultContainer } from '../../../../modal/detail-modal/default-container/default-container';
import { BasicAuthCreate } from '../basic-auth-create/basic-auth-create.component';
import { BasicAuthUpdate } from '../basic-auth-update/basic-auth-update.component';
import { useBasicAuthCard } from './basic-auth-card.controller';

export interface BasicAuthCardProps {
    entity_id: string;
    updateMode?: 'patch' | 'change-password';
    selfService?: boolean;
}

export const BasicAuthCard = (props: BasicAuthCardProps) => {
    const viewProps = useBasicAuthCard(props);
    return (
        <DefaultContainer
            title={
                <FormattedMessage
                    id='basic-auth-card.basic-authentication'
                    defaultMessage='Basic authentication'
                />
            }
            content={
                viewProps.isLoading && !viewProps.basicAuth ? (
                    <Spinner />
                ) : !viewProps.basicAuth ? (
                    <div className='text-foreground-muted text-base'>{CommonMessage.ERRORS.NO_BASIC_AUTH}</div>
                ) : (
                    <div className='inline-flex flex-col items-start justify-start gap-4 self-stretch'>
                        <div className='flex flex-col items-start justify-start gap-0.75'>
                            <div className='text-brand-muted justify-start text-base font-medium'>{CommonMessage.FORMS.EMAIL()} </div>
                            <div className='text-foreground-default w-52 justify-start text-base font-medium'>{viewProps.basicAuth?.key}</div>
                        </div>
                    </div>
                )
            }
            update={{
                onUpdate: () =>
                    viewProps.basicAuth
                        ? viewProps.openModal(viewProps.updateBasicAuthId, () => (
                              <BasicAuthUpdate
                                  basic_auth={viewProps.basicAuth!}
                                  user_id={props.entity_id}
                                  updateMode={props.updateMode}
                                  selfService={props.selfService}
                                  onSubmitSuccess={viewProps.setBasicAuth}
                              />
                          ))
                        : viewProps.openModal(viewProps.createBasicAuthId, () => (
                              <BasicAuthCreate
                                  entity_id={props.entity_id}
                                  selfService={props.selfService}
                                  onSubmitSuccess={viewProps.setBasicAuth}
                              />
                          ))
            }}
            {...(viewProps.basicAuth &&
                !props.selfService && {
                    delete: {
                        onDelete: () =>
                            viewProps.openModal(viewProps.deleteBasicAuthId, () => (
                                <DeleteModal
                                    func={() => IdentificationClient.deleteIdentification(viewProps.basicAuth!.account_id, viewProps.basicAuth!.id)}
                                    title={viewProps.basicAuth!.key}
                                    description={
                                        <FormattedMessage
                                            id='user.security.basicAuth.deleteDescription'
                                            description='Description for deleting basic auth modal'
                                            defaultMessage='Are you sure you want to delete this basic auth? This action cannot be undone.'
                                        />
                                    }
                                    callback={() => viewProps.setBasicAuth(null)}
                                    onDeleteSuccess={() => ToastUtil.success(CommonMessage.TOAST.DELETE.SUCCESS(viewProps.basicAuth!.key))}
                                    entityName={viewProps.basicAuth!.key}
                                />
                            ))
                    }
                })}
        />
    );
};
